import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import {getLanguage} from 'react-switch-lang';
import {getAllRiskTypes} from '../../services/reports/reports';
import {getAllDepartments} from '../../services/reports/kriReport';
import FormatList from './reportForm/components/format/FormatList';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import './Reports.scss';
import {format} from 'date-fns';
import {useUserContext} from '../../contexts/UserContext';
import SelectList from '../../components/FormFields/Select';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {formatDateTime} from '../../utils/formatDate';
import {parseISO} from 'date-fns';
import SelectInfinite from "../../components/FormFields/SelectInfinite";

const Measures = (props) => {
  const isValidType = '';
  const lang = getLanguage();
  const [selectedFormat, setSelectedFormat] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [riskTypes, setRiskTypes] = useState([]);
  const [format2, setFormat2] = useState('');
  const [apiParameters, setApiParameters] = useState([]);

  const fetchDepartments = async () => {
    try {
      const {data} = await getAllDepartments();
      setDepartments(data);
      return data;
    } catch (e) {}
  };
  const fetchRiskTypes = async () => {
    try {
      const {data} = await getAllRiskTypes();
      setRiskTypes(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    fetchRiskTypes().then((r) => {
      let riskTypes = [];
      r.forEach((item) => {
        riskTypes.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setRiskTypes(riskTypes);
    });

    fetchDepartments().then((r) => {
      let departments = [];
      r.forEach((item) => {
        departments.push(
          lang === 'eng'
            ? {value: item.id, label: item.nameEn}
            : {
                value: item.id,
                label: item.name,
              }
        );
      });

      setDepartments(departments);
    });
  }, []);

  const schema = yup.object().shape({
    department: yup.object().nullable().required(t('message.fieldRequired')),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue} = methods;
  let validFrom = watch('startDate');
  let validTo = watch('endDate');
  let validFromExtendedDate = watch('extendedDeadlineFrom');
  let validToExtendedDate = watch('extendedDeadlineTo');
  const departmentValue = watch('department');
  const riskTypeValue = watch('riskType');
  const riskStatusValue = watch('riskState');

  const user = useUserContext();
  // const departments = useUserDepartmentContext();
  let userRiskSector = false;
  let responsibleUser = false;
  let userInCharge = false;

  if (user.authorities) {
    user.authorities.forEach((item) => {
      if (item === 'ROLE_RISK_SECTOR') {
        userRiskSector = true;
      }
      if (item === 'ROLE_RESPONSIBLE_USER') {
        responsibleUser = true;
      }
      if (item === 'ROLE_USER_IN_CHARGE') {
        userInCharge = true;
      }
    });
  }

  useEffect(() => {
    setSelectedFormat();
    setIsSubmitted(false);
  }, []);

  const riskStatusList = [
    {value: 'OPEN', label: getLanguage() === 'mne' ? 'Otvoren' : 'Open'},
    {value: 'CLOSED', label: getLanguage() === 'mne' ? 'Zatvoren' : 'Closed'}, 
  ];

  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="startDate">
                {t('reports.dateFrom')}
              </label>
              <InputDate
                name="startDate"
                maxDate={validTo}
                defaultValue={
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                }
                className={`date-height form-control ${
                  validTo === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateFrom')}
              />
              {validTo === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className="form-group pr-5">
              <label className="label" htmlFor="endDate">
                {t('reports.dateTo')}
              </label>
              <InputDate
                name="endDate"
                minDate={validFrom}
                defaultValue={new Date()}
                className={`date-height form-control ${
                  validFrom === null && isSubmitted === true ? `error-field` : ''
                }`}
                isClearable={false}
                placeholderText={t('reports.dateTo')}
              />
              {validFrom === null && isSubmitted === true ? (
                <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>
              ) : (
                ''
              )}
            </div>
            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="department">
                {t('reports.kriReport.department')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="department"
                options={departments}
                placeholder={t('common.select')}
              />
            </div>
            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="riskType">
                {t('reports.riskType')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="riskType"
                options={riskTypes}
                placeholder={t('common.select')}
              />
            </div>
            <div className="form-group pr-5">
              <label className="label w-100" htmlFor="riskType">
                {t('reports.status')}
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <SelectList
                name="riskState"
                options={riskStatusList}
                placeholder={t('common.select')}
              />
            </div>
            <div className="form-group form-group-full-width pr-5">
              <label className="label w-100">
                {t('reports.extendedDeadlineFrom')} :
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <InputDate
                  name="extendedDeadlineFrom"
                  placeholder={t('codebook.lossDatePlaceholder')}
                  className={'date-input'}
                  maxDate={validToExtendedDate}
              />
            </div>

            <div className="form-group pr-5">
              <label className="label w-100">
                {t('reports.extendedDeadlineTo')} :
                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
              </label>
              <InputDate
                  name="extendedDeadlineTo"
                  placeholder={t('codebook.lossDatePlaceholder')}
                  className={'date-input'}
                  minDate={validFromExtendedDate}
              />
            </div>
            <FormatList
              isValidType={isValidType}
              value={['PDF', 'XLSX']}
              parameterName="format"
              onChange={(e) => setFormat2(e)}
              isSubmitted={isSubmitted}
              setIsSubmitted={() => setIsSubmitted(false)}
              setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
              error={!format2.length > 0}
            />
            <DownloadBtn
              api={'reports/risks/risk-report-measures'}
              paramsLength={8}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              // documentName={format2}
              documentName={`PDF`}
              apiParameters={{
                format: format2,
                startDate:
                  validFrom !== null && validFrom !== undefined
                    ? `startDate=${encodeURIComponent(
                        format(validFrom, 'yyyy-MM-dd')
                      )}`
                    : '',
                endDate:
                  validTo !== null && validTo !== undefined
                    ? `endDate=${encodeURIComponent(
                        format(validTo, 'yyyy-MM-dd')
                      )}`
                    : '',
                departmentId:
                  departmentValue !== null && departmentValue !== undefined
                    ? `departmentId=${watch('department').value}`
                    : 'departmentId=',
                // 'accept-language': `accept-language=${getLanguage()}`,
                riskTypeId:
                  riskTypeValue !== null && riskTypeValue !== undefined
                    ? `riskTypeId=${watch('riskType').value}`
                    : 'riskTypeId=',
                riskState:
                  riskStatusValue !== null && riskStatusValue !== undefined
                    ? `riskState=${watch('riskState').value}`
                    : 'riskState=',
                extendedDeadlineFrom:  validFromExtendedDate !== null && validFromExtendedDate !== undefined
                    ? `extendedDeadlineFrom=${encodeURIComponent(
                        format(validFromExtendedDate, 'yyyy-MM-dd')
                    )}`
                    : 'extendedDeadlineFrom=',
                extendedDeadlineTo:
                    validToExtendedDate !== null && validToExtendedDate !== undefined
                        ? `extendedDeadlineTo=${encodeURIComponent(
                            format(validToExtendedDate, 'yyyy-MM-dd')
                        )}`
                        : 'extendedDeadlineTo=',
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default Measures;
